<template>
	<div>
		<app-header />

		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item active" aria-current="page">
						{{ _lang("Users") }}
					</li>
				</ol>
			</nav>

			<table class="table">
				<tbody>
					<tr v-for="user in users" v-bind:key="user.id">
						<td>{{ user.name }}
							({{ user.email }})
							<span v-if="user.is_business_admin">[Admin]</span>
						</td>
						<td class="text-right"><router-link class="btn btn-light" :to="'/users/'+user.id">{{ _lang('Edit user') }}</router-link></td>
            <!-- td class="text-right"><router-link class="btn btn-light" :to="'/project/'+project.id+'/table/'+table.id+'/fields'">{{ _lang('Manage fields') }}</router-link></td>
            <td class="text-right"><router-link class="btn btn-primary" :to="'/project/'+project.id+'/table/'+table.id+'/browse'">{{ _lang('Manage data') }}</router-link></td> -->
					</tr>
				</tbody>
			</table>
			<router-link
				:to="'/users/new'"
				class="btn btn-primary"
				>{{ _lang("New user") }}</router-link
			>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import appHeader from "../components/appHeader.vue";

export default {
	name: "project",
	props: ["project_id"],
	components: {
		appHeader
	},
	data() {
		return {
			users: []
		};
	},
	methods: {
		//

		getUsers() {
			axios
				.get("/api/business/users")
				.then(response => {
					this.users = response.data;
				})
				.catch(error => {
					console.log(error);
				});
		}
	},
	mounted() {
		this.getUsers();
	}
};
</script>

<style></style>
